import { TASK_HEIGHT_COMPACT } from "../../gantt/helpers/Const";
import { DisplaySettings } from "../interfaces/states/IViewSettingsState";

const DisplaySettingDefaults: DisplaySettings = {
  dateFormat: "P", //long localized date
  timeFormat: "p", //long localized time
  showTimeInTable: true,
  showCurrentDay: true,
  startOfWeekDay: 1,
  taskHeight: TASK_HEIGHT_COMPACT,
  fullPrint: true,
  adjustForWeekendAndHolidays: false,
  showHolidays: true,
  allowAddAndEdit: true,
  stateInfo: {},
  notificationMessageTimeout: 10,
  refreshInterval: 0,
  colorOptions: [
    "#000000",
    "#276B67",
    "#2D5496",
    "#6A0026",
    "#CE5A0E",
    "#843B0A",
    "#453877",
    "#0B50C6",
    "#0686AF",
    "#637B00",
    "#D1A31A",
    "#1F0318",
    "#E5F2C9",
    "#7F534B",
    "#8C705F",
    "#1E1A1D",
    "#628395",
    "#96897B",
    "#DBAD6A",
    "#CF995F",
    "#D0CE7C",
    "#1098F7",
    "#B89E97",
    "#DECCCC",
  ],
  gridColumns: {},
};

export default DisplaySettingDefaults;